
require('./bootstrap');
window.Vue = require('vue');
import 'boxicons';
import 'boxicons/css/boxicons.min.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import swal from 'sweetalert';
import Pagination from 'vue-pagination-2';
Vue.config.devtools = false
Vue.component('apexchart',() => import('vue-apexcharts'));
Vue.component('admin-add-blog-component', () => import('./components/admin/blog/addPostComponent.vue'));
Vue.component('admin-add-gallery-image-component', () => import('./components/admin/blog/addGalleryImageComponent.vue'));
Vue.component('scrolltop-component', () => import('./components/scroll/scrollTopComponent.vue'));
Vue.component('scrolltop-arrow-component', () => import('./components/scroll/scrollTopArrowComponent.vue'));
Vue.component('dashboard-component', () => import('./components/admin/DashboardComponent.vue')); 
Vue.component('admin-activities-component',() => import('./components/admin/activitiesAdminComponent.vue'));
Vue.component('admin-add-admin-component', () => import('./components/admin/AddAdminUserComponent.vue'));
const app = new Vue({ 
    el: '#app',
    data(){
        return{
            emailLogAdmin:'',
            optionConnect:{
                chunk :5
            },
            passwordLogAdmin:'',
            isLoading: false,
            fullPage: true,
            inputGetUser:'',
            type_user:'',
            allUser:'',
            checkAllContact:'',
            allContactUs: [],
            pageConnect: 1,
            totalPageConnect:0,
            parPageConnect:'',
        }
    },
    created() {
        this.getAll();
    },
    components:{
        'apexchart':() => import('vue-apexcharts'),
        Loading,
        Pagination
    },
    methods: {
        callbackConnect: function(page) {
            var start_date=$('#dtp_input2').val();
            var end_date=$('#dtp_input3').val();
            if(start_date == '' && end_date=='' && this.checkAllContact == ''){
                swal("توجه", "لطفا ابتدا یکی از گزینه ها را انتخاب کنید", "error",{ button: "تایید"})
            }else{
                this.isLoading = true;
                axios.post('/admin/getContactUs?page='+page, {
                    end_date:end_date,
                    start_date:start_date,
                    AllContact:this.checkAllContact,
                }).then(response => {
                    this.allContactUs=response.data.data;
                    this.totalPageConnect=response.data.total;
                    this.parPageConnect=response.data.parPage;
                    this.isLoading = false
                }, response => {
                    this.isLoading = false;
                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")

                })
            }
            },
        getAllContactUs:function(){
            var start_date=$('#dtp_input2').val();
            var end_date=$('#dtp_input3').val();
            if(start_date == '' && end_date=='' && this.checkAllContact == ''){
                swal("توجه", "لطفا ابتدا یکی از گزینه ها را انتخاب کنید", "error",{ button: "تایید"})
            }else{
                this.isLoading = true;
                axios.post('/admin/getContactUs', {
                    end_date:end_date,
                    start_date:start_date,
                    AllContact:this.checkAllContact,
                }).then(response => {
                    this.allContactUs=response.data.data;
                    this.totalPageConnect=response.data.total;
                    this.parPageConnect=response.data.parPage;
                    this.isLoading = false
                }, response => {
                    this.isLoading = false;
                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")

                })
            }

        },
        submitAdminLogin:function(){
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (this.passwordLogAdmin == ''){
                swal("توجه", "لطفا فیلد پسورد را کامل نمایید", "error",{ button: "تایید"})
            }else if(this.emailLogAdmin == '' ){
                swal("توجه", "لطفا فیلد ایمیل را کامل نمایید", "error",{ button: "تایید"})
            }else if(reg.test(this.emailLogAdmin) == false ){
                swal("توجه", "الگو فیلد ایمیل اشتباه است", "error",{ button: "تایید"}).then(function () {
                    this.emailLogAdmin='';
                })
            }else{
                axios.post('/adminCheck', {
                    email:this.emailLogAdmin,
                }).then(response => {
                  if (response.data == 'ok'){
                      axios.post('/login', {
                          password:this.passwordLogAdmin,
                          email:this.emailLogAdmin,
                      }).then(response => {
                        axios.get('/admin/LogEnter', {
                        }).then(response => {
                            if(response.data =='ok'){
                                location.href = '/admin';
                            }else{
                                swal("توجه","اطلاعات ورود شما با هم مطابقت ندارد", "warning",{ button: "تایید"})
                            }

                        }, response => {
                            console.log('error');
                        })

                      }, response => {
                          swal("توجه","اطلاعات ورود شما با هم مطابقت ندارد", "warning",{ button: "تایید"})
                      })
                  }else{
                      swal("توجه","اطلاعات ورود شما با هم مطابقت ندارد", "warning",{ button: "تایید"})
                  }
                }, response => {
                    swal("توجه","اطلاعات ورود شما با هم مطابقت ندارد", "warning",{ button: "تایید"})
                })
            }

        },
        previewFilesCat:function(event){
            var here=this;
            var file = event.target.files[0];
            this.imageCategory=event.target.files[0];
            var FileSize = file.size; // in MB
            if (FileSize > 500000) {

                swal("توجه", "حجم فایل دریافتی نباید بیشتر از 500kb باشد", "error").then(function(){
                    $('.AddCat').find('input:file').val('');
                    here.imageCategory='';
                })

            }else{
                var ext =  $('.AddCat').find('input:file').val().match(/\.([^\.]+)$/)[1];
                switch (ext) {
                    case 'jpg':
                    case 'jpeg':
                    case 'png':
                        break;
                    default:
                        swal("توجه", "پسوند فایل شما باید png یا jpg باشد", "error").then(function(){
                            $('.AddCat').find('input:file').val('');
                            here.imageCategory='';
                        })

                }
            }
        },
        getAll(){
            var location=window.location.pathname;
            var lastPart=location.split('/')[2];
            if(lastPart == 'showUsersAdmin' ){
                this.isLoading = true;
            axios.get('/admin/getShowUsers').then(response => {
                this.allUser=response.data;
                this.isLoading = false
            }, response => {
                this.isLoading = false;
                console.log('error');
            })
            }
        },
        FilterInput: function (data) {

            if (this.inputGetUser.length == 0 ||this.inputGetUser == 0 )return true;

            if (data.name  !=null && data.name.match(this.inputGetUser)){
                return this.inputGetUser;
            }

        },
        Delete:function (id,image,name) {
            this.isLoading = true;
            axios.post('/admin/DestroyUser', {
                id:id,
                image:image,
                name:name,
            }).then(response => {
                this.getAll();
                this.isLoading = false
                swal("کاربر با موفقیت حذف گردید")
            }, response => {
                this.isLoading = false
                swal("ابتدا محصولات کاربر را باید حذف نمایید")
            })


        },
        EnglishType:function(event){
            var lang=this.lang;
            var arregex = /^[a-zA-Z0-9_ ]*$/;
            if (!arregex.test(event.key)) {
                event.preventDefault();
                switch (lang) {
                    case "en":
                        swal("Attention","The first and last name fields must be entered in English", "warning",{ button: "Ok"})
                        break;
                    case "fa":
                        swal("توجه","فیلد نام و نام خانوادگی باید انگلیسی وارد شود ", "warning",{ button: "تایید"})
                        break;
                    case "ar":
                        swal("انتباه","يجب إدخال حقلي الاسم الأول والأخير باللغة الإنجليزية", "warning",{ button: "فهمت"})
                        break;
                    default:
                        swal("Attention","The first and last name fields must be entered in English", "warning",{ button: "Ok"})
                        break;
                }

            }
        },
        ZeroType:function(){
            var lang=this.lang;
            $('#phoneNumber').on('keyup', function () {
                var number=$('#phoneNumber').val();
                var one = number.toString()[0];
                if (one == 0) {
                    switch (lang) {
                        case "en":
                            swal("Attention","Enter your phone number without zero", "warning",{ button: "Ok"})
                            break;
                        case "fa":
                            swal("توجه","شماره تلفن خود را بدون صفر وارد کنید", "warning",{ button: "تایید"})
                            break;
                        case "ar":
                            swal("انتباه","أدخل رقم هاتفك بدون صفر", "warning",{ button: "فهمت"})
                            break;
                        default:
                            swal("Attention","Enter your phone number without zero", "warning",{ button: "Ok"})
                            break;
                    }
                    $('#phoneNumber').val("");
                }
                var two = number.toString()[1];
                var prefix=$('#ContRegister').val();
                if (two == 8 && prefix=='98') {
                    switch (lang) {
                        case "en":
                            swal("Attention","Enter the mobile number field according to the template", "warning",{ button: "Ok"})
                            break;
                        case "fa":
                            swal("توجه","فیلد شماره تلفن همراه را مطابق الگو وارد نمایید", "warning",{ button: "تایید"})
                            break;
                        case "ar":
                            swal("انتباه","أدخل حقل رقم الهاتف المحمول وفقًا للقالب", "warning",{ button: "فهمت"})
                            break;
                        default:
                            swal("Attention","Enter the mobile number field according to the template", "warning",{ button: "Ok"})
                            break;
                    }
                    $('#phoneNumber').val("");
                }
            });
        },
        ZeroTypeAdmin:function(event){
                var number=event.target.value;
                var one = number.toString()[0];
                if (one == 0) {
                    swal("توجه","شماره تلفن خود را بدون صفر وارد کنید", "warning",{ button: "تایید"}).then(function () {
                        event.target.value='';
                    })

                }
                var two = number.toString()[1];
                var prefix=$('#ContRegister').val();
                if (two == 8 && prefix=='98') {
                    swal("توجه","فیلد شماره تلفن همراه را مطابق الگو وارد نمایید", "warning",{ button: "تایید"}).then(function () {
                        event.target.value='';
                    })
                }

        },
    },
});
